import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';
import initScrollDirection from './utilities/scroll-direction';

import initMenu from './components/menu';
import initCookies from './components/cookies';
import initHomeHero from './components/home-hero';
import initListing from './components/dashboard-listing';
import initVideoEmbed from './components/video-embed';
import initFilterfrom from './components/filter';
import initMap from './components/map';
import initScrollBtns from './components/scroll';
import initVideoPopup from './components/video-popup';

initCookies();

initScrollDirection();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menuEl = document.querySelector('.js-menu');

if (menuEl) {
    initMenu(menuEl);
}

const homeHeroEl = document.querySelector('.js-home-hero');

if (homeHeroEl) {
    initHomeHero(homeHeroEl);
}

const listingEl = document.querySelector('.js-listing');

if (listingEl) {
    initListing(listingEl);
}

const videoEmbedEls = document.querySelectorAll('.js-video-embed');

if (videoEmbedEls && videoEmbedEls.length > 0) {
    initVideoEmbed(videoEmbedEls);
}

const filterEl = document.querySelector('.js-filter');

if (filterEl) {
    initFilterfrom(filterEl);
}

const mapEl = document.querySelector('.js-map');

if (mapEl) {
    initMap(mapEl);
}

const scrollBtns = document.querySelectorAll('.js-scroll-to');

if (scrollBtns && scrollBtns.length > 0) {
    initScrollBtns(scrollBtns);
}

const videoPopupEls = document.querySelectorAll('.js-video-popup-play');

if (videoPopupEls && videoPopupEls.length > 0) {
    initVideoPopup(videoPopupEls);
}
